export const scrollTo = (target: Element, container: Element, offset?: number) => {
  const headerOffset = offset || 0;
  const elementPosition =
    target.getBoundingClientRect().top - container.getBoundingClientRect().top;
  const offsetPosition = elementPosition + container.scrollTop - headerOffset;

  container.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};
